// extracted by mini-css-extract-plugin
module.exports =  {"sidePane":"sidePane__aLz7U","cardBase":"cardBase__hpXvR","cardCaption":"cardCaption__ArSpA flexAlignCenter__GndC6","dashboardLinks":"dashboardLinks__8C1oS cardBase__hpXvR"};